import { render, staticRenderFns } from "./dpa.vue?vue&type=template&id=1d3a3c46&scoped=true"
import script from "./dpa.vue?vue&type=script&lang=js"
export * from "./dpa.vue?vue&type=script&lang=js"
import style0 from "./dpa.vue?vue&type=style&index=0&id=1d3a3c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a3c46",
  null
  
)

export default component.exports